module.exports = __webpack_public_path__ + "img/recupel2.f88450b6.jpg";